import { isExpired, existAllProps } from './../helpers';

export const ScanValidator = {

    /**
     * Valida el tiempo de expiración del token del QR u origen escaneado
     * @param {number} expireIn Tiempo en milisegundos 
     */
    validateTimeExpired: (expireIn) => {

        return isExpired(expireIn);
    },

    /**
     * Verifica si el beneficio está contenido dentro del código escaneado
     * @param {Object} scanned Data escaneada
     */
    validateExistPropBenefitId: (scanned) => {

        return existAllProps(scanned, ['benefitId']);
    }
};